import { useCallback } from 'react';
import { useAnalytic } from '@skooldio/analytics-provider';

function useTracking() {
  const { ga } = useAnalytic();
  const logAction = useCallback(
    (action) => {
      try {
        ga.event(action);
      } catch (error) {
        console.error(error);
      }
    },
    [ga]
  );

  return { logAction };
}

export default useTracking;
